import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";
export const contractRouter: RouteRecordRaw[] = [
    {
        path: "/contract",
        name: "ContractManagement",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/contract/contract",
        meta: {
            title: "合同管理"
        },
        children: [
            {
                path: "contract",
                name: "Contract",
                component: () => import("@/views/pages/contractManagement/index.vue"),
                meta: {
                    title: "合同管理",
                    hidden: true,
                    activeMenu: "ContractManagement",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "contractDetail",
                name: "ContractDetail",
                component: () => import("@/views/pages/contractManagement/detail.vue"),
                meta: {
                    title: "合同详情",
                    activeMenu: "ContractManagement",
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ]
                }
            },
            {
                path: "contractAdd",
                name: "ContractAdd",
                component: () => import("@/views/pages/contractManagement/form.vue"),
                meta: {
                    title: "新增合同",
                    activeMenu: "ContractManagement",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "contractEdit",
                name: "ContractEdit",
                component: () => import("@/views/pages/contractManagement/form.vue"),
                meta: {
                    title: "修改合同",
                    activeMenu: "ContractManagement",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];
